import { client } from '../../..'
import { WITHDRAW_MEETING_REQUEST } from '../MeetingMutations'
import { MEETINGS_AND_REQUESTS_BY_REPLYER } from '../MeetingRequestQueries'
import { WithdrawRequestedMeetingMutation, WithdrawRequestedMeetingMutationVariables } from '../../../types'
import { FetchResult } from '@apollo/client'

export default (): {
  withdrawMeeting: (meetingRequesterId: number, requestId: number) => Promise<FetchResult<WithdrawRequestedMeetingMutation>>
} => {
  const withdrawMeeting = async (meetingRequesterId: number, requestId: number): Promise<FetchResult<WithdrawRequestedMeetingMutation>> => {
    return await client.mutate<WithdrawRequestedMeetingMutation, WithdrawRequestedMeetingMutationVariables>({
      mutation: WITHDRAW_MEETING_REQUEST,
      variables: {
        employeeId: meetingRequesterId,
        requestId: requestId,
      },
      refetchQueries: [
        {
          query: MEETINGS_AND_REQUESTS_BY_REPLYER,
          variables: {
            replyerId: meetingRequesterId,
          },
        },
      ],
      awaitRefetchQueries: true,
    })
  }

  return { withdrawMeeting }
}
